import type { LineItem } from 'types/mafia';

export default (lineItems: LineItem[] | undefined, itemIds: string[]): LineItem[] => {
  if (!lineItems || lineItems.length < 1 || itemIds.length < 1) {
    return [];
  }
  return lineItems.filter(lineItem => {
    const contractUnitId = lineItem.returnDetails?.contractUnitId;
    const cancellable = !!lineItem.returnDetails?.cancellable;
    return contractUnitId && itemIds.includes(contractUnitId) && cancellable;
  });
};
